import 'twin.macro';
import React from 'react';
import { LivretSearchResult } from '@teetsh/app/src/containers/Search/types';
import { format } from '@teetsh/app/src/utils/time/format';
import { DescriptionList } from '@teetsh/app/src/components/DescriptionList';
import isValid from '@teetsh/app/src/utils/time/isValid';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  livret: LivretSearchResult;
}

export function LivretPreview(props: Props) {
  const { livret } = props;
  const { locale } = useUser();
  const { t } = useTranslation(['common']);
  return (
    <div tw="p-6">
      <div tw="text-xl font-bold mb-4">{livret.name}</div>

      <DescriptionList>
        {isValid(livret.createdAt) && (
          <DescriptionList.Item label={t('common:search.results.createdAt')}>
            {format(livret.createdAt, locale, 'eeee dd MMMM yyyy à hh:mm')}
          </DescriptionList.Item>
        )}
        <DescriptionList.Item label={t('common:search.results.classroom')}>
          {livret.classroomName}
        </DescriptionList.Item>
        <DescriptionList.Item label={t('common:search.results.periodName')}>
          {livret.periodeName}
        </DescriptionList.Item>
        <DescriptionList.Item label={t('common:search.results.periodDates')}>
          {t('common:search.results.datex_to_datey', {
            from: format(livret.periodeFrom, locale, 'dd MMMM yyyy'),
            to: format(livret.periodeTo, locale, 'dd MMMM yyyy'),
          })}
        </DescriptionList.Item>
      </DescriptionList>
    </div>
  );
}
